import { useEffect, useMemo, useState } from 'react'

import useApiGet from 'Pods/Shared/Hooks/useApiGet'
import { getAssetByTypeAndSource } from 'Pods/ThreeDStudio/Shared/Utils/getAssetByTypeAndSource'

import { toAspectRatio } from './useGalleryImages'

// The image endpoint serializes a run rather than a gallery row, so its file and ratio sit
// on the output asset. Returns null when there is no file to show.
const toGalleryImage = (attributes) => {
  if (!attributes) return null

  const { id, slug, title, prompt, createdAt, user, outputAssets } = attributes
  const { assetId, fileUrl, aspectRatio } = getAssetByTypeAndSource(outputAssets, 'image', 'ai_generated')
  if (!fileUrl) return null

  return {
    id,
    slug,
    assetId,
    title: title ?? prompt ?? '',
    prompt,
    createdAt,
    user,
    src: fileUrl,
    aspectRatio: toAspectRatio(aspectRatio),
  }
}

// Loads one community image by slug, for a URL naming an image the gallery has not loaded:
// a shared link, or an image past the pages fetched so far. Pass null to skip.
function useGalleryImageBySlug(slug) {
  const { getData } = useApiGet()
  const [loaded, setLoaded] = useState(null)

  useEffect(() => {
    if (!slug) return

    getData({
      path: `/api/internal/generator/images/${slug}`,
      onSuccess: (response) => {
        setLoaded({ slug, attributes: response?.data?.data?.attributes ?? null })
      },
    })
  }, [getData, slug])

  // Keyed on the slug so a stale image never shows while the next one loads.
  const attributes = slug && loaded?.slug === slug ? loaded.attributes : null

  return useMemo(() => toGalleryImage(attributes), [attributes])
}

export default useGalleryImageBySlug
